module.exports = __webpack_public_path__ + "assets/img/9-small.30df7a62.png";